import React from "react";
import { Box, Circle, Grid3X3, MapPin, Camera, Zap, Spline, GitMerge } from "lucide-react";
import { JointIcon, ExplosionIcon } from "../../ui/Icons";

// Single source of truth lives in property-panels/QuickNavReparent so the icon
// looks identical across the inspector and the scene-graph context menus.
export { ReparentMenuIcon } from "../../property-panels/QuickNavReparent";

export const SceneNodeIcon = React.memo(function SceneNodeIcon({ type }) {
  let icon;
  switch (type) {
    case "body":
      icon = <Box className="w-4 h-4" />;
      break;
    case "joint":
      icon = <JointIcon className="w-3 h-3" />;
      break;
    case "mesh":
      icon = <Grid3X3 className="w-2.5 h-2.5" />;
      break;
    case "geom":
      icon = <ExplosionIcon className="w-2 h-2" />;
      break;
    case "site":
    case "attachment_site":
      icon = <MapPin className="w-2.5 h-2.5" />;
      break;
    case "inertial":
      icon = <Circle className="w-2.5 h-2.5" />;
      break;
    case "camera":
      icon = <Camera className="w-3 h-3" />;
      break;
    case "actuator":
      icon = <Zap className="w-3 h-3" />;
      break;
    case "tendon":
      icon = <Spline className="w-3 h-3" />;
      break;
    case "equality":
      icon = <GitMerge className="w-3 h-3" />;
      break;
    default:
      icon = <Circle className="w-3 h-3" />;
      break;
  }
  return <div className="w-full h-full flex items-center justify-center text-white">{icon}</div>;
});
